import { combineReducers } from 'redux'
import * as actions from '../actions/actionTypes'
import { IGuiState, IState } from '../store/state';
//import {toggleQuickBetting} from "../actions/quickBet";

// lets set the initial channel to 1 - or to the value of optional url-parameter
const query = new URLSearchParams(window.location.search);
const option = parseInt(query.get('selectchannel'), 10);
const selectChannel: number = (query && option && option>=1 && option <=4) ? option : 1;

const initialState : IGuiState = {
    carousel: {
        index: 0, // starting index
        loop: false, // if the carousel is loop able
        autoplay: false, // if the carousel rotates it content automaticaly
        changeContentPause: 6000, // the pause between the auto rotation in milliseconds
        manualMode: false, // if the user interactes in some kinds with the overlay this is true,
        contentNames: new Array()
    },
    overlay: {
        visibility: false
    },
    channel: {
        active: selectChannel
    },
    quickBetsState: {
        active: false
    },
    video:{
        isPaused: true
    },
    isApplicationReady: false,
    latestVideoPlayerAction: undefined,
    betstops: {},
}

//
export const getInitApplicationState = (state : IState) => state.gui.isApplicationReady

//
export const getVideoPlayerPauseState = (state : IState) => state.gui.video.isPaused

//
export const getLatestVideoPlayerOperation = (state : IState) => state.gui.latestVideoPlayerAction

//channel getter functions
// get the active channel object
export const getActiveChannelId = (state : IState) => state.gui.channel.active

//overlay getter functions
export const getOverlayVisibility = ( state: IState) => state.gui.overlay.visibility

// get the whole overlay state
export const getOverlayState = ( state: IState ) => state.gui.overlay

//carousel getter functions
export const getCarouselContentIndex = ( state: IState ) => state.gui.carousel.index

export const getCarouselContentHeadlineName = ( state: IState ) =>
    state.gui.carousel.contentNames.length
        ? state.gui.carousel.contentNames[getCarouselContentIndex(state)].headline
        : null

export const getCarouselContentSubtitleName = ( state: IState ) =>
    state.gui.carousel.contentNames.length
        ? state.gui.carousel.contentNames[getCarouselContentIndex(state)].subtitle
        : null

export const getCarouselLoopState = ( state: IState ) => state.gui.carousel.loop

export const getCarouselAutoplayState = ( state: IState ) => state.gui.carousel.autoplay

export const getCarouselChangeContentPause = ( state: IState ) => state.gui.carousel.changeContentPause

// matchlist getter functions
export const isQuickBetsActive = (state : IState) => state.gui.quickBetsState.active;


// overlay setter functions
// this will work as long as the loop functionality is only available for the auto mode carousel
export const getCarouselManualmode = ( state: IState ) => state.gui.carousel.manualMode

// get the whole carousel state
export const getCarouselState = ( state: IState ) => state.gui.carousel

// returns the current betstop state in the store for a given matchid
export const getBetstopByMatchId = ( state: IState, matchId: number ) : boolean | undefined => {
    return typeof state.gui.betstops[ matchId ] == 'boolean' ? state.gui.betstops[ matchId ] : undefined;
}

// channel setter functions
const setActiveChannel = (channelState:any, activeChannelIndex: number) => ({
    ...channelState,
    active: activeChannelIndex
})

//overlay setter functions
const changeOverlayVisibility = (overlayState: any, state: boolean) => ({
    ...overlayState,
    visibility: state
})

//carousel setter functions
const changeCarouselAutomode = (carouselState: any, state: boolean) => ({...carouselState, autoplay: state, loop: state})

const changeCarouselManualmode = (carouselState: any, state: boolean) => ({...carouselState, autoplay: false, loop: false, manualMode: state})

const changeCarouselContentIndex = ( carouselState: any, value: number ) => ({...carouselState, index: value})

const changeCarouselContent = ( carouselState: any, values: any ) => ({...carouselState, index: values.index, contentName: values.name})

const setCarouselContentName = ( carouselState: any, names: any ) => ({...carouselState, contentNames: names })

const setPlayerApi = (pervPlayerApiState: any, newPlayerApiState: any) => {
    return ({...pervPlayerApiState, ...newPlayerApiState})
}

// show or hide odds
const toggleQuickBetting = (quickBetsState: any) => {
    // just invert the state if called and return the value
    let state = quickBetsState.active === false ? true : false;
    return {...quickBetsState, active: state}
}

//Overlay Reducer
const gui = ( state: IGuiState = initialState, action: any ) : IGuiState => {
    switch ( action.type ) {

        // overlay actions
        case actions.INIT_APPLICATION_FINISHED:
            return Object.assign({}, state, {isApplicationReady: true})

        // betstop actions
        case actions.BETSTOP_CHANGE:
            const res = {
                ...state,
                betstops: {...state.betstops, [ action.matchId ]: action.isBetstop },
            };

            return res;

        // overlay actions
        case actions.OVERLAY_TOGGLE:
            return Object.assign({}, state, {overlay: changeOverlayVisibility(state.overlay, !state.overlay.visibility)})
        case actions.OVERLAY_SHOW:
            return Object.assign({}, state, {overlay: changeOverlayVisibility(state.overlay, true)})
        case actions.OVERLAY_HIDE:
            return Object.assign({}, state, {overlay: changeOverlayVisibility(state.overlay, false)})

        // carousel actions
        case actions.CAROUSEL_INDEX_CHANGE:
            return Object.assign({}, state, {carousel: changeCarouselContentIndex(state.carousel, action.value)})
        case actions.CAROUSEL_CONTENT_CHANGE:
            return Object.assign({}, state, {carousel: changeCarouselContent(state.carousel, action.values)})
        case actions.CAROUSEL_CONTENT_NAME_SET:
            return Object.assign({}, state, {carousel: setCarouselContentName(state.carousel, action.values)})
        case actions.CAROUSEL_AUTOMODE_TOGGLE:
            return Object.assign({}, state, {carousel: changeCarouselAutomode(state.carousel, !state.carousel.autoplay)})
        case actions.CAROUSEL_AUTOMODE_START:
            return Object.assign({}, state, {carousel: changeCarouselAutomode(state.carousel, true)})
        case actions.CAROUSEL_AUTOMODE_STOP:
            return Object.assign({}, state, {carousel: changeCarouselAutomode(state.carousel, false)})
        case actions.CAROUSEL_MANUALMODE_TOGGLE:
            return Object.assign({}, state, {carousel: changeCarouselManualmode(state.carousel, !state.carousel.manualMode)})
        case actions.CAROUSEL_MANUALMODE_START:
            return Object.assign({}, state, {carousel: changeCarouselManualmode(state.carousel, true)})
        case actions.CAROUSEL_MANUALMODE_STOP:
            return Object.assign({}, state, {carousel: changeCarouselManualmode(state.carousel, false)})

        //Channel actions
        case actions.CHANGE_CHANNEL:
            return Object.assign({}, state, {channel: setActiveChannel(state.channel, action.id)})
        case actions.TOGGLE_QUICK_BETTING:
            return Object.assign({}, state, {quickBetsState: toggleQuickBetting(state.quickBetsState)})

        //Video actions
        case actions.VIDEO_PLAYER_STOP:
            return Object.assign({}, state, {video: { isPaused: true }})
        case actions.VIDEO_PLAYER_PLAY:
            return Object.assign({}, state, {video: { isPaused: false }})
        case actions.VIDEO_PLAYER_ACTION:
            return Object.assign({},state, {latestVideoPlayerAction: action.videoPlayerOperation})
        case actions.MATCH_PURGE:
            return Object.assign({}, state, {
                betstops: Object.keys(state.betstops).filter( key => key !== action.id ).map( matchId => state.betstops[matchId as any] ),
            });
        default:
            return state
    }
}

export default gui
